/*
  Project: Unit
  Author: Via Studios
 */

import initToggles from './modules/toggles';
import { initPlayOnHover } from './modules/hovers';
import initGallerySlider from './modules/gallery-slider';
import infiniteContent from './modules/infinite-content';
import './modules/menu-anchor';
import './modules/menu-split';

document.addEventListener('DOMContentLoaded', () => {
  initToggles();
  infiniteContent();
  initPlayOnHover();

  const theme = document.querySelector(
    '.c-theme:not(.page-template-template-category):not(.c-theme--front-page)',
  );
  if (theme) {
    const firstHeading = theme.querySelector('h1');
    if (firstHeading) {
      firstHeading.style.color = '#eae93a'; // Replace with your yellow color variable if needed
    }
  }
});

initGallerySlider();



// WEBPACK FOOTER //
// ./src/scripts/app.js